import React, { useState } from 'react';
import { Box, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { Navbar } from './Navbar';
import { Sidebar } from './Sidebar';
import { Footer } from './Footer';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleDrawerToggle = () => {
    if (isMobile) {
      setMobileOpen(!mobileOpen);
    } else {
      setDesktopOpen(!desktopOpen);
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', flexDirection: 'column' }}>
      <Navbar onMenuClick={handleDrawerToggle} isSidebarOpen={isMobile ? mobileOpen : desktopOpen} />
      
      <Box sx={{ display: 'flex', flex: 1 }}>
        {!isMobile && desktopOpen && (
          <Sidebar 
            open={desktopOpen} 
            onClose={() => setDesktopOpen(false)}
            variant="permanent"
          />
        )}
        {isMobile && (
          <Sidebar 
            open={mobileOpen} 
            onClose={() => setMobileOpen(false)}
            variant="temporary"
          />
        )}
        
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Toolbar />
          <Box sx={{ flex: 1 }}>
            {children}
          </Box>
        </Box>
      </Box>
      <Footer />
    </Box>
  );
};
